import { render, staticRenderFns } from "./Discover.vue?vue&type=template&id=65d4a353&scoped=true&"
import script from "./Discover.vue?vue&type=script&lang=js&"
export * from "./Discover.vue?vue&type=script&lang=js&"
import style0 from "./Discover.vue?vue&type=style&index=0&id=65d4a353&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d4a353",
  null
  
)

export default component.exports